var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-title"},[_c('fm-input-new',{attrs:{"value":_vm.title,"placeholder":"请输入任务标题"},on:{"blur":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }